import { useAuthStore } from '../store/authStore'
import { useSettingsStore } from '../store/settingsStore'

export default class TooUploadAdapter {
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader
  }

  // Starts the upload process.
  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          this._initRequest()
          this._initListeners(resolve, reject, file)
          this._sendRequest(file)
        }),
    )
  }

  // Aborts the upload process.
  abort() {
    if (this.xhr) {
      this.xhr.abort()
    }
  }

  // Initializes the XMLHttpRequest object using the URL passed to the constructor.
  _initRequest() {
    const xhr = (this.xhr = new XMLHttpRequest())
    xhr.open(
      'POST',
      `${import.meta.env.VITE_API_BASE_URL}/management/v1/images`,
      true,
    )
    xhr.responseType = 'json'
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners(resolve, reject, file) {
    const xhr = this.xhr
    const loader = this.loader
    const genericErrorText = `Couldn't upload file: ${file.name}.`

    xhr.addEventListener('error', () => reject(genericErrorText))
    xhr.addEventListener('abort', () => reject())
    xhr.addEventListener('load', () => {
      const response = xhr.response

      if (!response || response.error) {
        return reject(
          response && response.error ? response.error : genericErrorText,
        )
      }

      resolve({
        default: response.data.url,
      })
    })

    if (xhr.upload) {
      xhr.upload.addEventListener('progress', (evt) => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total
          loader.uploaded = evt.loaded
        }
      })
    }
  }

  // Prepares the data and sends the request.
  _sendRequest(file) {
    // Prepare the form data.
    const data = new FormData()
    const settingsStore = useSettingsStore()
    const authStore = useAuthStore()

    data.append('imageFile', file)

    this.xhr.setRequestHeader('Authorization', `Bearer ${authStore.token}`)
    if (settingsStore.activePublisher.id) {
      this.xhr.setRequestHeader('X-Publisher', settingsStore.activePublisher.id)
    }

    // Send the request.
    this.xhr.send(data)
  }
}
